module.exports = __webpack_public_path__ + "static/img/league1.5c0ec67d.png";